var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import classNames from "classnames";
import { artOptionLabelCls, artOptionLabelUpperCls } from "./Label.less";
var ArtOptionLabel = /* @__PURE__ */ __name(function ArtOptionLabel2(_ref) {
  var _ref$uppercase = _ref.uppercase, uppercase = _ref$uppercase === void 0 ? true : _ref$uppercase, children = _ref.children;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(artOptionLabelCls, uppercase && artOptionLabelUpperCls)
  }, children);
}, "ArtOptionLabel");
export {
  ArtOptionLabel
};
